import { CloseCircleOutlined, InboxOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { Select } from "antd";
import { Form } from "antd";
import { Upload } from "antd";
import { Tooltip } from "antd";
import { Spin } from "antd";
import { Modal } from "antd";
import { Table } from "antd";
import TextArea from "antd/lib/input/TextArea";
import Dragger from "antd/lib/upload/Dragger";
import { max, min } from "moment";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

const { Option } = Select;

export const LanListChanelWiseWithPayout = (props) => {
  const {
    landatasource,
    pagination,
    onPageChange,
    partnerList,
    handelAddRemap,
    fileStatus,
    getfilemonth,
    prevMonthName,
    downloading
  } = props;
  const [form] = Form.useForm();
  const [editableRow, setEditableRow] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [ispmapremarkVisble, setPmapremarkVisble] = useState(false);
  const [makerAction, setMakerAction] = useState(true);
  // const [existingpartnerId, setExistingpartnerId] = useState(partnerId);
  const [pmapremark, setPmapremark] = useState("");
  const [payoutFileList, setPayoutFileList] = useState([]); // State to manage file upload
  const [emailconfData, setEmailconfDataData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // ...existing code...
  }, [landatasource]);

  const handeleRealocationClick = async (record) => {

    if (editableRow && selectedPartner === null) {
      message.error("Please Select Partner to proceed");
      return;
    }
    // await getpartnerList();
    // Implement your reallocation logic here

    setEditableRow(record);
  };

  useEffect(() => {
  }, [editableRow]);

  const removeFileFromList = () => {
    setPayoutFileList([]);
  };

  const handleCloseModalpmapremark = () => {
    setPmapremarkVisble(false);
    setPmapremark("");
    form.resetFields(); // Reset the form fields
    setPayoutFileList([]);
    setEditableRow(null);
    setSelectedPartner(null);
  };

  const handelecancelallocation = () => {
    setEditableRow(null);
    form.resetFields();
    setPayoutFileList([]);
    setPmapremarkVisble(false);
    setPmapremark("");
    setSelectedPartner(null);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    if (value.length <= 250) {
      setPmapremark(value);
    } else {
      message.error("You can only enter a maximum of 250 characters.");
    }
  };

  const handleFileChange = (info) => {
    if (
      info.file.status === "done" ||
      info.file.status === "uploading" ||
      info.file.status === "error"
    ) {
      setEmailconfDataData((prev) => ({
        ...prev,
        emailconfDataPath: info.file.originFileObj,
      }));
    }
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: ".pdf",
    showUploadList: {
      showPreviewIcon: false,
      showRemoveIcon: true,
      showDownloadIcon: false,
      removeIcon: <span>✖</span>,
    },
    fileList: payoutFileList,
    customRequest: async ({ file, onSuccess, onError }) => {
      try {
        onSuccess("ok");
      } catch (err) {
        onError("Upload failed. Please try again.");
        message.error("Upload failed. Please try again.");
      }
    },
    beforeUpload: (file) => {
      // Check if a file is already present
      if (payoutFileList && payoutFileList.length > 0) {
        message.error("You can only upload one file.");
        setPayoutFileList([]);
        return Upload.LIST_IGNORE;
      }

      const isPDF =
        file.type === "application/pdf" &&
        file.name.toLowerCase().endsWith(".pdf");
      if (!isPDF) {
        message.error("Only PDF documents are allowed.");
        setTimeout(() => {
          setPayoutFileList([]);
          setEmailconfDataData((prev) => ({ ...prev, emailconfDataPath: null })
          );
        }, 300);
        return Upload.LIST_IGNORE;
      }
      const isLt250KB = 5 * 1024  * 1024;
      if (file.size >= isLt250KB) {
        message.error("File must be smaller than 5MB.");
        setTimeout(() => {
          setPayoutFileList([]);
          setEmailconfDataData((prev) => ({ ...prev, emailconfDataPath: null })
          );
        }, 300);
        return Upload.LIST_IGNORE;
      }
      message.success("File is attached succesfully.");
      return true;
    },
    onRemove: () => {
      setEmailconfDataData((prev) => ({ ...prev, emailconfDataPath: null }));
      setPayoutFileList([]);
      removeFileFromList();
    },
    onChange: (info) => {
      // Only update file list if the file is valid
      const validFiles = info.fileList.filter(f =>
        f.type === 'application/pdf' &&
        f.name.toLowerCase().endsWith('.pdf') &&
        f.size <= 5 * 1024  * 1024
      );
      setPayoutFileList(validFiles);
      handleFileChange(info);
    },
  };

  const handlePartnerChange = (value, record) => {
    const getpartner = partnerList.find(
      (partner) => partner.partnerFirmId === value)

    // if (record.partnerId && getpartner.pricingAdded === false) {
    //   setEditableRow(null);
    //   setSelectedPartner(null);

    //   return message.error("Selected partner does not have pricing added. Please select another partner for remap.");
    // }
    
    setSelectedPartner(value);
    setPmapremarkVisble(true);
    form.resetFields();
    setPayoutFileList([]);
    setPmapremark("");
    // setExistingpartnerId(partnerId)
  };

  const columns = [
    {
      title: "Applicant Name",
      dataIndex: "applicantName",
      key: "applicantName",
      align: "center",
      width: 200,
    },
    {
      title: "Dibursement File No",
      dataIndex: "lanNo",
      key: "lanNo",
      align: "center",
      width: 190,
    },
    {
      title: "Disbursal Date",
      dataIndex: "disbDate",
      key: "disbDate",
      align: "center",
      width: 190,
    },
    {
      title: "Lan Status",
      dataIndex: "lanStatus",
      key: "lanStatus",
      align: "center",
      width: 190,
    },
    {
      title: "Source Type",
      dataIndex: "sourceType",
      key: "sourceType",
      align: "center",
      width: 190,
    },
    {
      title: "Source By",
      dataIndex: "sourceBy",
      key: "sourceBy",
      align: "center",
      width: 190,
    },
    editableRow?.transactionId
      ? {
        title: "Partner Name",
        dataIndex: "partnerName",
        key: "partnerName",
        align: "center",
        fixed: "right",
        width: 200,
        render: (text, record) => {
          return editableRow?.transactionId === record.transactionId ? (
            <Select
              value={selectedPartner || record.partnerId}
              onChange={(value) => {
                handlePartnerChange(value, record);
              }}
              showSearch
              placeholder="Select Partner"
              style={{ width: "100%", minWidth: "200px" }}
              optionFilterProp="children"
            >
              {partnerList?.map((partner) => (
                <Option
                  style={{ color: partner.pricingAdded ? "black" : "red" }}
                  key={partner.partnerFirmId}
                  value={partner.partnerFirmId}
                >
                  {partner.partnerFirmName}
                </Option>
              ))}
            </Select>
          ) : (
            text
          );
        },
      }
      : {
        title: "Partner Name",
        dataIndex: "partnerName",
        key: "partnerName",
        align: "center",
        width: 200,
        render: (text, record) => {
          return editableRow?.transactionId === record.transactionId ? (
            <Select
              value={selectedPartner || record.partnerId}
              onChange={(value) => {
                handlePartnerChange(value, record);
              }}
              showSearch
              placeholder="Select Partner"
              style={{ width: "100%", minWidth: "200px" }}
              optionFilterProp="children"
            >
              {partnerList?.map((partner) => (
                <Option
                  style={{ color: partner.pricingAdded ? "black" : "red" }}
                  key={partner.partnerFirmId}
                  value={partner.partnerFirmId}
                >
                  {partner.partnerFirmName}
                </Option>
              ))}
            </Select>
          ) : (
            text
          );
        },
      },
    {
      title: "Partner Code",
      dataIndex: "partnerCode",
      key: "partnerCode",
      align: "center",
      width: 190,
    },
    {
      title: "1st Disb Amount",
      dataIndex: "firstDisbAmount",
      key: "firstDisbAmount",
      align: "center",
      width: 190,
      render: (_, amount) => (amount.firstDisbAmount > 0 ? amount.firstDisbAmount : 0).toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: "Tranche Disb Amount",
      dataIndex: "disbAmount",
      key: "disbAmount",
      align: "center",
      width: 190,
      render: (_, record) =>
        (record.disbAmount > 0 ? record.disbAmount : 0).toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
        }),
    },

    ...(
      makerAction && (fileStatus === "Pending with CET Maker") && (getfilemonth === prevMonthName)
        ? [{
          title: "Action",
          dataIndex: "Action",
          key: "Action",
          fixed: "right",
          align: "center",
          width: 100,
          render: (_, record) => {
            const isDisabled = (record.lanRemapped === true) || (record.lanOnHold === true) || (record.disbAmount > 0) || (record.lanStatus === 'Reject');
            const isDisabledrealo = (record.lanRemapped === true) || (record.lanOnHold === true) || (record.disbAmount > 0) || (record.lanStatus === 'Reject'); //we can not realocate disbSeq=2 or more

            let reason = "";
            if (record.lanRemapped === true) {
              reason = `Already ${record.partnerId ? "remapped" : "reallocated"}`;
            } else if (record.lanOnHold === true) {
              reason = "LAN is on hold";
            } else if (record.disbAmount > 0) {
              reason = `Tranch Disbursal cannot be ${record.partnerId ? "remapped" : "reallocated"}`;
            } else if (record.lanStatus === 'Reject') {
              reason = `LAN with Reject status cannot be ${record.partnerId ? "remapped" : "reallocated"}`;
            }

            const buttonStyle = {
              fontSize: "0.8rem",
              backgroundColor: isDisabled || isDisabledrealo ? "#f5f5f5" : "#1b8593",
              color: isDisabled || isDisabledrealo ? "#bfbfbf" : "#fff",
              margin: "3px",
              borderRadius: "5px",
              minWidth: "90%",
              border: isDisabled ? "1px solid #d9d9d9" : "none",
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 1 : 1,
            };

            const buttonStylerealo = {
              fontSize: "0.8rem",
              backgroundColor: isDisabledrealo ? "#f5f5f5" : "#1b8593",
              color: isDisabledrealo ? "#bfbfbf" : "#fff",
              margin: "3px",
              borderRadius: "5px",
              minWidth: "90%",
              border: isDisabledrealo ? "1px solid #d9d9d9" : "none",
              cursor: isDisabledrealo ? "not-allowed" : "pointer",
              opacity: isDisabledrealo ? 1 : 1,
            };

            if (
              record.partnerName === null ||
              record.partnerName === "" ||
              record.partnerName === undefined
            ) {
              return (
                <>
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <Tooltip title={isDisabledrealo ? reason : ""} placement="left">
                      <Button
                        type="primary"
                        style={buttonStylerealo}
                        disabled={isDisabledrealo}
                        onClick={() => handeleRealocationClick(record)}
                      >
                        Reallocate
                      </Button>
                    </Tooltip>
                    {editableRow?.transactionId === record.transactionId && (
                      <span style={{ color: "#1b8593", fontSize: "0.8rem" }}>
                        <CloseCircleOutlined onClick={handelecancelallocation} />
                      </span>)}
                  </div>
                </>
              );
            } else {
              return (
                <>
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <Tooltip title={isDisabled ? reason : ""} placement="left">
                      <Button
                        type="primary"
                        style={buttonStyle}
                        disabled={isDisabled}
                        onClick={() => handeleRealocationClick(record)}
                      >
                        Remap
                      </Button>
                    </Tooltip>
                    {editableRow?.transactionId === record.transactionId && (
                      <span style={{ color: "#1b8593", fontSize: "0.8rem" }}>
                        <CloseCircleOutlined onClick={handelecancelallocation} />
                      </span>
                    )}
                  </div>
                </>
              );
            }
          },
        }]
        : []
    ),

  ];

  const handelsavePremark = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (pmapremark === null || pmapremark.trim() === "") {
      message.error("Please add remark to proceed");
      setIsLoading(false);
      return;
    } else if (emailconfData.emailconfDataPath === null || emailconfData.emailconfDataPath === undefined) {
      message.error("Please attach the supporting document");
      setIsLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("oldPartnerId", editableRow.partnerId || -1);
    formData.append("newPartnerId", selectedPartner);
    formData.append("lanNo", editableRow.lanNo);
    formData.append("payoutId", editableRow.payoutId || -1); //@nikhil start sending payoutId or set as -1 if null
    formData.append("remarks", pmapremark);
    formData.append("file", emailconfData.emailconfDataPath);
    formData.append("remapStageId", 3);
    formData.append("userRole", props.userDetail.roleName);
    formData.append("createdBy", props.userDetail.userId);



    try {
      const res = await handelAddRemap(formData);


      if (!res || res.code >= 400 || res.code === "ERR_BAD_REQUEST") {
        throw new Error(res?.message || "Network error or invalid response");
      }

      // Success message and state updates
      message.success("Partner remap request successfully added", 3);
      setEditableRow(null);
      form.resetFields(); // Reset the form fields
      setPayoutFileList([]);
      setPmapremarkVisble(false);
      setPmapremark("");
      setSelectedPartner(null);
    } catch (error) {
      // Handle errors gracefully
      console.error("Error during partner remap request:", error);
      message.error(
        `Partner remap request error: ${error.message || "An unexpected error occurred"}`,
        3
      );
    } finally {
      // Ensure loading state is reset
      setIsLoading(false);
    }
  };

  return (
    <div>
      {downloading && (
        <div style={{
          position: 'absolute',
          zIndex: 10,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(255,255,255,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Spin tip="Loading..." size="large" />
        </div>
      )}
      <Table
        dataSource={landatasource}
        pagination={pagination}
        showSizeChanger={true}
        onChange={(pagination) => {
          // Call the parent's handler if provided
          if (props.onPageChange) {
            props.onPageChange(pagination.current, pagination.pageSize);
          }
        }}
        columns={columns}
        rowKey={(record, index) => index}
        scroll={{ x: "max-content", y: "calc(100vh - 300px)" }}
      />

      <Modal
        title="Add Remark"
        visible={ispmapremarkVisble}
        onCancel={handleCloseModalpmapremark}
        footer={null}
      >
        <Form form={form}>
          <Form.Item
            name="pmapremark"
            required
            rules={[
              { required: true, message: "Please add Query Remark" },
              {
                validator: (_, value) => {
                  if (
                    value &&
                    value.split(/\s+/).filter(Boolean).length > 250
                  ) {
                    return Promise.reject("Remark cannot exceed 250 words");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <TextArea
              placeholder="Please add comment to submit"
              onChange={(e) => handleChange(e)}
              autoSize={{ minRows: 2, maxRows: 6 }}
              value={pmapremark}
              maxLength={250}
              showCount={true}
            />
          </Form.Item>
          <Form.Item>
            <Dragger
              {...uploadProps}
              style={{ marginTop: "0.3rem", marginBottom: "0.3rem" }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
            </Dragger>
          </Form.Item>
          <Form.Item>
            <Button
              disabled={pmapremark === null}
              type="link"
              onClick={(e) => handelsavePremark(e)}
              style={{
                background: "#1b8593",
                marginTop: "0.3rem",
                color: "#fff",
              }}
              loading={isLoading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanListChanelWiseWithPayout);
